import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SneakerIcon, TShirtIcon } from '@phosphor-icons/react'

import {
  Alert,
  BonusChip,
  DeliveryMethodSelector,
  OptionButton,
  PriceChip,
  SplitButton,
  StoreCreditIcon,
  Text,
} from '@reveni-io/reveni-ui'

import WhiteLabelThemeProvider from '@/configuration/components/WhiteLabelThemeProvider/WhiteLabelThemeProvider'

import { mockDeliveryMethods, mockRefundOption, selectorSubTabs } from '../constants'
import { buildSelectorPreviewTheme } from './helpers'
import * as Styles from './styles'

const SelectorsPreview = ({ colors, activeSubTab = selectorSubTabs.methodRequest }) => {
  const { t } = useTranslation()
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [selectedVariantIndex, setSelectedVariantIndex] = useState(0)

  const buildPreviewTheme = whiteLabelTheme => buildSelectorPreviewTheme(colors, whiteLabelTheme)

  const renderMethodRequestPreview = () => (
    <WhiteLabelThemeProvider buildTheme={buildPreviewTheme}>
      <Styles.MethodRequestContainer>
        <Styles.SplitButtonWrapper isSelected={selectedIndex === 0} onClick={() => setSelectedIndex(0)}>
          <SplitButton
            label={t('Otra talla/color')}
            icon={
              <>
                <TShirtIcon size={40} color="white" />
                <TShirtIcon size={28} color="white" />
              </>
            }
          />
        </Styles.SplitButtonWrapper>
        <Styles.SplitButtonWrapper isSelected={selectedIndex === 1} onClick={() => setSelectedIndex(1)}>
          <SplitButton
            label={t('Un producto diferente')}
            icon={
              <>
                <TShirtIcon size={40} color="white" />
                <SneakerIcon size={28} color="white" />
              </>
            }
          />
        </Styles.SplitButtonWrapper>
        <Styles.DeliveryMethodWrapper onClick={() => setSelectedIndex(2)}>
          <DeliveryMethodSelector
            methods={mockDeliveryMethods}
            deliveryMethodSelected={selectedIndex === 2 ? mockDeliveryMethods[0] : null}
            onChange={() => setSelectedIndex(2)}
            currency="EUR"
          />
        </Styles.DeliveryMethodWrapper>
        <Styles.RefundOption isSelected={selectedIndex === 3} onClick={() => setSelectedIndex(3)}>
          <Styles.RefundOptionHeader>
            <Styles.RefundIconContainer>
              <StoreCreditIcon size={32} />
            </Styles.RefundIconContainer>
            <Styles.RefundOptionTitleContainer>
              <Text type="titleM">{t(mockRefundOption.label)}</Text>
              <Styles.RefundOptionChipsContainer>
                <BonusChip label={`${mockRefundOption.extraCredit} extra`} />
                <PriceChip isActive label={`${t('Coste adicional')} ${mockRefundOption.feeAmount}€`} />
              </Styles.RefundOptionChipsContainer>
            </Styles.RefundOptionTitleContainer>
          </Styles.RefundOptionHeader>
          <Styles.HelperText>{t(mockRefundOption.helperText)}</Styles.HelperText>
          <Styles.TotalAmountContainer>
            <Text type="bodyMBold">
              {t('Total reembolso')}: {mockRefundOption.refundAmount}€
            </Text>
          </Styles.TotalAmountContainer>
        </Styles.RefundOption>
      </Styles.MethodRequestContainer>
    </WhiteLabelThemeProvider>
  )

  const renderVariantPreview = () => {
    const variants = [
      { label: 'S', isSelected: selectedVariantIndex === 0 },
      { label: 'M', isSelected: selectedVariantIndex === 1 },
      { label: 'L', isSelected: selectedVariantIndex === 2 },
      { label: 'XL', isSelected: selectedVariantIndex === 3 },
    ]

    return (
      <WhiteLabelThemeProvider buildTheme={buildPreviewTheme}>
        <Styles.VariantsContainer>
          {variants.map((variant, index) => (
            <OptionButton
              key={index}
              name={variant.label}
              isSelected={variant.isSelected}
              onClick={() => setSelectedVariantIndex(index)}
            />
          ))}
        </Styles.VariantsContainer>
      </WhiteLabelThemeProvider>
    )
  }

  return (
    <Styles.Container>
      <Styles.PreviewContent>
        {activeSubTab === selectorSubTabs.methodRequest ? renderMethodRequestPreview() : renderVariantPreview()}
        <Styles.AlertWrapper>
          <Alert type="info">
            {t('Para ver el estilo hover coloca el cursor sobre los selectores. Haz click para cambiar su estado.')}
          </Alert>
        </Styles.AlertWrapper>
      </Styles.PreviewContent>
    </Styles.Container>
  )
}

export default SelectorsPreview
